"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion_1 = require("./Accordion");
exports.default = Accordion_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/Accordion/index.js
// module id = 790
// module chunks = 8